














import { Component, Prop, Vue, Provide } from 'vue-property-decorator';

@Component
export default class BlockRadioGroup extends Vue {
  @Prop() private list: any;
  private value: any;

  // 某一项被选择
  private select(item: any) {
    for (const i of this.list) {
      i.selected = false;
    }
    item.selected = true;
    this.value = item;
    this.$emit('input', this.value);
  }
  
}
